export default __webpack_public_path__ + "media/images/spinningwheel/sw-alpha-119054a1e21b045c0f6a997dda3769b3.png";